import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import CustomButton from "Components/Custom/CustomButton";
import CustomInput from "Components/Custom/CustomInput";

interface PaymentMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (paymentMethod: "cash" | "stripe" | null) => void;
  currentPaymentMethod: "cash" | "stripe" | null;
  isLoading?: boolean;
}

const PaymentMethodModal: React.FC<PaymentMethodModalProps> = ({
  isOpen,
  onClose,
  onSave,
  currentPaymentMethod,
  isLoading = false,
}) => {
  const [selectedMethod, setSelectedMethod] = useState<"cash" | "stripe" | null>(
    currentPaymentMethod || "stripe"
  );

  useEffect(() => {
    if (isOpen) {
      setSelectedMethod(currentPaymentMethod || "stripe");
    }
  }, [isOpen, currentPaymentMethod]);

  const handleSave = () => {
    onSave(selectedMethod);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      contentClassName="br-12"
      size="md"
    >
      <ModalHeader
        toggle={onClose}
        className="bg-greyF5 p-3 br-12 font-primary fw-medium fs-16 text-black2D border-bottom-0"
      >
        Payment Method
      </ModalHeader>
      <ModalBody className="p-4 bg-white br-12">
        <div className="mb-4">
          <CustomInput
            name="paymentMethod"
            label=""
            type="select"
            value={selectedMethod || ""}
            onChange={(e: any) =>
              setSelectedMethod(e.target.value as "cash" | "stripe" | null)
            }
            dropdownOptions={[
              { label: "Stripe", value: "stripe" },
              { label: "Cash", value: "cash" },
            ]}
          />
        </div>

        <div className="d-flex justify-content-start">
          <CustomButton
            text="Save Item"
            className="bg-primary px-4 py-2 border-7"
            onClick={handleSave}
            loading={isLoading}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default React.memo(PaymentMethodModal);

